import {
  DeleteButton,
  EditButton,
  Icons,
  List,
  useModalForm,
  useTable,
} from "@pankod/refine-antd";
import { Table } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { AkgPriceRange } from "interfaces/akg-price-range";
import { AkgPriceRangeCreate } from "./create";
import { AkgPriceRangeEdit } from "./edit";

export const AkgPriceRangeList: React.FC<IResourceComponentsProps> = ({
  name,
}) => {
  const { tableProps } = useTable<AkgPriceRange.AkgPriceRangeItem>({
    resource: name,
    initialSorter: [
      {
        field: "sortOrder",
        order: "asc",
      },
    ],
    initialPageSize: 10,
  });

  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: showCreateModal,
  } = useModalForm({
    resource: name,
    action: "create",
    submitOnEnter: true,
    redirect: false,
    successNotification: {
      type: "success",
      message: "Fiyat aralığı başarıyla oluşturuldu.",
    },
    onMutationSuccess: () => {
      createFormProps.form.resetFields();
    },
  });

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: showEditModal,
  } = useModalForm<AkgPriceRange.AkgPriceRangeItem>({
    resource: name,
    action: "edit",
    submitOnEnter: true,
    redirect: false,
    successNotification: {
      type: "success",
      message: "Fiyat aralığı başarıyla güncellendi.",
    },
  });

  const formatPrice = (value: number | null) => {
    if (value === null || value === undefined) return "Sınırsız";
    return `₺${Number(value).toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <List
      resource={name}
      title="AKG Fiyat Aralıkları"
      createButtonProps={{
        type: "primary",
        size: "large",
        shape: "round",
        icon: <Icons.PlusCircleFilled />,
        onClick: () => showCreateModal(),
        children: "Yeni Fiyat Aralığı Oluştur",
      }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="sortOrder"
          title="Sıra"
          key="sortOrder"
          sorter
          width={80}
        />
        <Table.Column
          dataIndex="min"
          title="Min Fiyat"
          key="min"
          sorter
          render={(value) => <span>{formatPrice(value)}</span>}
        />
        <Table.Column
          dataIndex="max"
          title="Max Fiyat"
          key="max"
          sorter
          render={(value) => <span>{formatPrice(value)}</span>}
        />
        <Table.Column
          dataIndex="akg"
          title="AKG"
          key="akg"
          sorter
          render={(value) => <span>{formatPrice(value)}</span>}
        />
        <Table.Column
          dataIndex="akgPlus"
          title="AKG Plus"
          key="akgPlus"
          sorter
          render={(value) => <span>{formatPrice(value)}</span>}
        />
        <Table.Column<AkgPriceRange.AkgPriceRangeItem>
          title="İşlemler"
          dataIndex="actions"
          render={(_, record) => (
            <>
              <EditButton
                resourceNameOrRouteName={name}
                size="small"
                onClick={() => showEditModal(record.id)}
              >
                Düzenle
              </EditButton>
              <DeleteButton
                resourceNameOrRouteName={name}
                recordItemId={record.id}
                size="small"
                successNotification={{
                  type: "success",
                  message: "Fiyat aralığı başarıyla silindi.",
                }}
              >
                Sil
              </DeleteButton>
            </>
          )}
        />
      </Table>

      <AkgPriceRangeCreate
        formProps={createFormProps}
        modalProps={createModalProps}
      />
      <AkgPriceRangeEdit
        formProps={editFormProps}
        modalProps={editModalProps}
      />
    </List>
  );
};
